module.exports = __webpack_public_path__ + "static/sf-partner-huawei-5708c57dd5da36791d5d6fadb9742e8e.png";